import { branch, compose, defaultProps, lifecycle, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { getAdverts } from '../../../store/reducers/content';
import { withLoadingHandlers } from '../../../components/with-loader';
import { withLoader } from '../../../components/template';
import { Widget } from '../../../widgets/adverts/component';
import { DEFAULT_ADVERT_NO_GROUP_KEY } from '../../../helpers/advert/advert';

const mapStateToProps = ({ content }, { groupName = DEFAULT_ADVERT_NO_GROUP_KEY }) => ({
  adverts: content.adverts[groupName] ?? [],
  loadingAdverts: content.loadingAdverts[groupName]
});
const CustomPageAdverts = compose(
  connect(mapStateToProps, { getAdverts }),
  // to make adverts fit the page grid
  defaultProps({ grid: true, edge: true }),
  withLoadingHandlers(true),
  lifecycle({
    async componentDidMount() {
      const { getAdverts, turnOnLoading, turnOffLoading, groupName } = this.props;

      turnOnLoading();
      await getAdverts({ groupName });

      turnOffLoading();
    }
  }),
  withLoader,
  branch(({ adverts, loading }) => !loading && adverts.length < 1, renderNothing)
)(Widget);

CustomPageAdverts.displayName = 'CustomPageAdverts';

export { CustomPageAdverts };
